<img class="animated-logo" src="/images/animated-logo.gif" alt="Loading…" />

<ng-container *ngFor="let message of rotatingMessages">
    <div *ngIf="message === currentMessage" class="info-message">{{ message }}</div>
</ng-container>

<div class="additional-message">(This may take a minute)</div>
